import RytmWebflow from 'rytm-webflow'
// import { TweenMax, Power0, Power1, Power2, Power3, Power4, Back, Bounce, Elastic, Expo, Sine } from 'gsap'

class View extends RytmWebflow.View {

  constructor(id) {
    super(id)
  }
  /**
  * animate in (show)
  **/  
  show(container) {
    super.show(container)
  }
  /**
  * animate out (hide)
  **/
  hide(container) {
    super.hide(container)
  }

}

export default View